import React, { useState } from 'react';
import './ClickableText.css';
import PopUp from '../PopUp/PopUp';


const ClickableText = ({ clickableProject, clickableTag }) => {

    const [isUserModalOpen, setUserModalOpen] = useState(false)
    const [selection, setSelection] = useState(null)
    const [popUpType, setpopUpType] = useState(null)

    // const handleClick = (title) => {
    //     if (setSelectedProjectTitle && setUserModalOpen) {
    //         setSelectedProjectTitle(title); 
    //         setUserModalOpen(true);
    //     }     
    // };

    const renderComponent = () => {
        if (clickableProject) return <h3 onClick={() => handleClick()}>{clickableProject}</h3>
        if (clickableTag) return <h3 onClick={() => handleClick()}>{clickableTag}</h3>
        // if (condition2) return <Component2 />;
        // if (condition3) return <Component3 />;
        return ''
    };

    const handleClick = () => {
        setUserModalOpen(true)

        if (clickableProject) {
            setSelection(clickableProject)
            setpopUpType('project')
        }

        if (clickableTag) {
            setSelection(clickableTag)
            setpopUpType('tag')
        }
    }

    return (
        <div className='clickableText'>
            {renderComponent()}
            <PopUp
                isOpen={isUserModalOpen}
                onClose={() => setUserModalOpen(false)}
                popUpType={popUpType}
                selection={selection}
            />
        </div>
    );
}

export default ClickableText;
